document.addEventListener("DOMContentLoaded", (event) => {

  // Get the current URL
  var currentURL = window.location.href;

  // Function to parse URL parameters and keep allowed parameters
  function removeURLParameters(url) {
    var allowedParams = ['utm_source', 'utm_medium', 'utm_campaign', 'preview_smart_cart', 'viewcart', 'preview', 'preview_smart_search', 'q', 'preview_smart_cart', 'viewcart', 'cart_version', 'view'];
    var urlObj = new URL(url);

    if (urlObj.search.includes("?q=returns")) {
      window.location.href = "pages/returns";
    }

    if (urlObj.search.includes("?q=contact")) {
      window.location.href = "pages/contact-us";
    }
    
    // Create an object to store the UTM parameters to keep
    const filteredParams = {};
    
    // Iterate through the URL's search parameters
    for (const [param, value] of urlObj.searchParams) {
      console.log(param, value);
      // Check if the parameter is one of the UTM parameters to keep
      if (allowedParams.includes(param)) {
        // Add the parameter to the filteredParams object
        filteredParams[param] = value;
      }
    }
    
    // Remove all existing search parameters from the URL
    urlObj.search = '';
    
    // Add back only the filtered UTM parameters
    for (const param in filteredParams) {
      urlObj.searchParams.set(param, filteredParams[param]);
    }
    
    // Return the modified URL
    var newURL = urlObj.toString();
  
    var params = new URLSearchParams(urlObj.search);

    // Filter and keep allowed parameters
    for (var key of params.keys()) {
      if (!allowedParams.includes(key)) {
        params.delete(key);
      }
    }    

    // Create the new URL without unwanted parameters
    if(params.toString()){
      var newURL = urlObj.origin + urlObj.pathname + '?' + params.toString();
    } else {
      var newURL = urlObj.origin + urlObj.pathname;
    }

    // Check if the URL ends with a trailing slash
    if (newURL.endsWith('/')) {
      // Remove the trailing slash
      newURL = newURL.slice(0, -1);
    }
    console.log("newURL", newURL);
    return newURL;
  }

  // Remove unwanted URL parameters
  var newURL = removeURLParameters(currentURL);

  // Update the URL without refreshing the page
  history.replaceState(null, null, newURL);
  
  document.addEventListener(
    "click",
    function (event) {
      const triggerClass = event.target.classList.contains(
        "collapsible-trigger"
      );

      if (triggerClass) {
        let currentIsActive =
          event.target.parentElement.classList.contains("active");
        for (
          var i = 0;
          i < document.getElementsByClassName("faq-wrapper").length;
          i++
        ) {
          document
            .getElementsByClassName("faq-wrapper")
            [i].classList.remove("active");
        }
        // document.getElementsByClassName("faq-wrapper").classList.remove("active");
        if (currentIsActive != 1) {
          event.target.parentElement.classList.add("active");
          event.target.setAttribute("aria-expanded", "true");
        } else {
          event.target.setAttribute("aria-expanded", "false");
        }
      }
    },
    false
  );

  // script for showing/hiding transcript
  const transcriptClass = document.getElementsByClassName(
    "show-transcript-btn"
  );

  for (const showTranscript of transcriptClass) {
    showTranscript.addEventListener("click", function onClick() {
      var showText = showTranscript.getAttribute("data-show-text");
      var hideText = showTranscript.getAttribute("data-hide-text");
      // var container = showTranscript.closest(".collapsible-content");
      //  container.style.height = '100%';
      var buttonText = showTranscript.innerHTML;

      if (buttonText === "Show Transcript") {
        showTranscript.innerHTML = hideText;
        showTranscript.parentElement.nextElementSibling.classList.add("show");
      } else {
        showTranscript.innerHTML = showText;
        showTranscript.parentElement.nextElementSibling.classList.remove(
          "show"
        );
      }
    });
  }

  // script for FAQ tabs
  function openFaqTabs() {
    var href = window.location.href;
    var findTerm = function (term) {
      if (href.includes(term)) {
        return href;
      }
    };

    switch (href) {
      case findTerm("order-support-faq"):
        var element = document.querySelectorAll(".nav-tabs li");
        for (var i = 0; i < element.length; i++) {
          element[0].classList.add("active");
        }
        break;
      case findTerm("mouthpieces-faq"):
        var element = document.querySelectorAll(".nav-tabs li");
        for (var i = 0; i < element.length; i++) {
          element[1].classList.add("active");
        }
        break;
      case findTerm("noise-reduction-faq"):
        var element = document.querySelectorAll(".nav-tabs li");
        for (var i = 0; i < element.length; i++) {
          element[3].classList.add("active");
        }
        break;
      case findTerm("anti-snoring-devices-faq"):
        var element = document.querySelectorAll(".nav-tabs li");
        for (var i = 0; i < element.length; i++) {
          element[2].classList.add("active");
        }
        break;
      case findTerm("snoring-solutions-faq"):
        var element = document.querySelectorAll(".nav-tabs li");
        for (var i = 0; i < element.length; i++) {
          element[3].classList.add("active");
        }
        break;
      default:
        var element = document.querySelectorAll(".nav-tabs li");
        for (var i = 0; i < element.length; i++) {
          element[i].classList.remove("active");
        }
    }
  }

  openFaqTabs();

  function setSelectedValue(selectObj, valueToSet) {
    if (!selectObj) return;
    for (var i = 0; i < selectObj.options.length; i++) {
      if (selectObj.options[i].text == valueToSet) {
        selectObj.options[i].selected = true;
        return;
      }
    }
  }

  function collectionDropdown() {
    var href = window.location.href;
    var findTerm = function (term) {
      if (href.includes(term)) {
        return href;
      }
    };

    switch (href) {
      case findTerm("shop-all-products"):
        var objSelect = document.getElementById("collectionFilters");
        setSelectedValue(objSelect, "SHOP ALL");
        break;
      case findTerm("shop-all-mouthpieces"):
        var objSelect = document.getElementById("collectionFilters");
        setSelectedValue(objSelect, "SNORING SOLUTIONS");
        break;
      case findTerm("shop-all-noise-protection"):
        var objSelect = document.getElementById("collectionFilters");
        setSelectedValue(objSelect, "SNORING NOISE PROTECTION");
        break;
      case findTerm("shop-all-refills"):
        var objSelect = document.getElementById("collectionFilters");
        setSelectedValue(objSelect, "REORDERS & SUBSCRIPTIONS");
        break;
      default:
        var objSelect = document.getElementById("collectionFilters");
        setSelectedValue(objSelect, "SELECT PRODUCT CATEGORY");
    }
  }

  collectionDropdown();

  var faqSelect = document.getElementById("faqSelect");
  if (faqSelect) {
    faqSelect.onchange = function () {
      var faqURL = this.value;
      if (faqURL != "") {
        window.location = faqURL;
      }
    };
  }
});

// script to scroll to section on success page
function scrollToTarget(event) {
  event.preventDefault();

  var headerHeight = document.querySelector("header").offsetHeight; // Get the header height
  var targetId = this.getAttribute("href").substring(1); // Get the target element's ID
  var targetElement = document.getElementById(targetId); // Get the target element

  // Calculate the scroll position with header height offset
  var scrollPosition =
    targetElement.getBoundingClientRect().top +
    window.pageYOffset -
    headerHeight;
  
  // Scroll smoothly to the target element
  window.scrollTo({ top: scrollPosition, behavior: "smooth" });
}

// Get all href links on the page
var links = document.querySelectorAll("a.btn--success[href^='#']");

// Attach event listeners to the success links
links.forEach(function (link) {
  link.addEventListener("click", scrollToTarget);
});

checkContradictions();

function removeCartItem(variantId) {
  checkContradictions();
  var formData = {
    id: variantId,
    quantity: 0,
  };

  fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      document.dispatchEvent(new CustomEvent("cart:build"));
      var element = document.getElementsByClassName("template-cart");
      for (i = 0; i < element.length; i++) {
        element[i].classList.remove("unloading");
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function radiobuttonClick(ele) {
  const closestAncestor = ele.closest(".product-single__meta");
  var VarInput = document.querySelectorAll(".variant-input");

  for (var i = 0; i < VarInput.length; i++) {
    VarInput[i].classList.remove("active");
  }
  ele.classList.add("active");
  closestAncestor
    .querySelectorAll(".payment-buttons button[type=submit]")[0]
    .removeAttribute("disabled");
  closestAncestor
    .querySelectorAll(
      ".payment-buttons .shopify-payment-button__more-options"
    )[0]
    ?.removeAttribute("disabled");
  closestAncestor
    .querySelectorAll(
      ".product-single__meta.has-variant .variant-input-wrap .color-red"
    )[0]
    ?.remove();
}

// back to top JS
const backToTop = document.getElementById("backToTop");

if (backToTop) {
  backToTop.addEventListener("click", function (event) {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
  window.addEventListener("scroll", function () {
    if (window.pageYOffset > 500) {
      backToTop.style.display = "block";
      backToTop.classList.add("back-show");
    } else {
      backToTop.style.display = "none";
      backToTop.classList.remove("back-show");
    }
  });
}

function emptyCartDrawer() {
  fetch(window.Shopify.routes.root + "cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: '',
  })
    .then((response) => response.json())
    .then((data) => {
      document.dispatchEvent(new CustomEvent("cart:build"));
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

if($(".product__photos .product__main-photos").length > 0)
{
  var currentHeight = $(".product__photos .product__main-photos .product-main-slide:first-child .image-wrap").outerHeight();
  $(".product__photos .product__main-photos .product-slideshow").css("height", currentHeight+"px");
}
$(window).on("load", function () {
  if($(".product__photos .product__main-photos").length > 0)
  {
    $(".product__photos .product__main-photos .product-slideshow").css("height", "auto");
  }
});
$(document).ready(function () {
  // resize the slide-read-more Div
  var box = $(".slide-read-more");
  var minimumHeight = 50; // max height in pixels
  var initialHeight = box.innerHeight();
  // reduce the text if it's longer than 200px
  if (initialHeight > minimumHeight) {
    box.css("height", minimumHeight);
    $(".read-more-button").show();
  }

  SliderReadMore();

  function SliderReadMore() {
    $(".slide-read-more-button").on("click", function () {
      // get current height
      var currentHeight = box.innerHeight();

      // get height with auto applied
      var autoHeight = box.css("height", "auto").innerHeight();

      // reset height and revert to original if current and auto are equal
      var newHeight =
        (currentHeight | 0) === (autoHeight | 0) ? minimumHeight : autoHeight;

      box.css("height", currentHeight).animate({
        height: newHeight
      });
      // $("html, body").animate({
      //   scrollTop: box.offset().top
      // });
      $(".slide-read-more-button").toggle();
    });
  }
});

